//imports
import {
    COMPANIES_OVERVIEW_GET_DATA_REQUEST,
    COMPANIES_OVERVIEW_GET_DATA_RESULT,
    GET_TOKEN_ONE_TIME_RESULT,
    GET_TOKEN_ONE_TIME,
    CLEAR_REDUX
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    company: null,
    error: null,
    tokenOneTime: null,
    loadingToken: false
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case COMPANIES_OVERVIEW_GET_DATA_REQUEST:
            return { ...state, loading: true };
            
        case COMPANIES_OVERVIEW_GET_DATA_RESULT:
            return { ...state, loading: false, company: action.payload.data, error: action.payload.error };

        case CLEAR_REDUX:
            return ["", "ACCOUNT_OVERVIEW"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        case GET_TOKEN_ONE_TIME_RESULT:
            return { ...state, tokenOneTime: action.payload, loadingToken: false };

        case GET_TOKEN_ONE_TIME:
            return { ...state, tokenOneTime: null, loadingToken: true };

        default:
            return state;
    }
};
